import { render, staticRenderFns } from "./UnitsInputComponent.vue?vue&type=template&id=96b49984"
import script from "./UnitsInputComponent.vue?vue&type=script&lang=js"
export * from "./UnitsInputComponent.vue?vue&type=script&lang=js"
import style0 from "./UnitsInputComponent.vue?vue&type=style&index=0&id=96b49984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports